/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import Colors from '../../constants/Colors';
import Title from './Title';

function SectionTitle({
  title,
  subtitle,
  theme = 'light',
}: {
  title: string,
  subtitle?: string,
  theme?: 'light' | 'dark',
}) {
  if (!subtitle) {
    return (
      <Title align="center" size="32" weight="black" color={ThemeStyles[theme].TitleColor}>
        {title}
      </Title>
    );
  }

  return (
    <div>
      <Title align="center" size="40" weight="black" color={ThemeStyles[theme].TitleColor}>
        {title}
      </Title>
      <Title
        align="center"
        color={ThemeStyles[theme].SubtitleColor}
        size="18"
        className={Styles.Subtitle}>
        {subtitle}
      </Title>
      <div className={Styles.Divider} />
    </div>
  );
}
export default SectionTitle;

const ThemeStyles = {
  light: {
    TitleColor: Colors.Black,
    SubtitleColor: Colors.IndigoLight,
  },
  dark: {
    TitleColor: Colors.White,
    SubtitleColor: Colors.IndigoLight,
  },
};

const Styles = {
  Divider: css`
    background-color: ${Colors.Yellow};
    height: 5px;
    margin: 0 auto;
    width: 80px;
  `,
  Subtitle: css`
    margin-top: 15px;
    margin-bottom: 25px;
  `,
};



// WEBPACK FOOTER //
// ./src/ui/components/core/SectionTitle.js